import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Preloader from "../helper/Preloader";
import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";

const OrderInfo = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { transactionId, reference, infoData } = location.state || {};

  // If no infoData is provided, redirect to home
  React.useEffect(() => {
    if (!infoData) {
      navigate('/');
    }
  }, [infoData, navigate]);

  if (!infoData) {
    return null;
  }

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderTwo category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={t('order_info.title') || 'Order Information'} />

      {/* Main Content */}
      <section className="order-info py-80">
        <div className="container container-lg">
          <div className="py-40 text-center">
            <div className="mb-24">
              <i className="text-main-500 ph-bold ph-info-circle" style={{ fontSize: '64px' }}></i>
            </div>
            <h3 className="mb-16">{t('order_info.title') || 'Order Information'}</h3>
            <p className="mb-16 text-gray-500">{t('order_info.message') || 'Please review the following information for your order.'}</p>
            
            {reference && (
              <p className="mb-16">
                <span className="fw-semibold">{t('order_info.reference')}:</span> <span className='tw-text-xl'>#{reference}</span>
              </p>
            )}
            
            {/* Display the info data */}
            <div className="mx-auto mt-24 mb-32 text-left" style={{ maxWidth: '600px' }}>
              <div className="p-24 border border-gray-100 bg-gray-50 rounded-8">
                {infoData && typeof infoData === 'object' ? (
                  Object.entries(infoData).map(([key, value]) => (
                    <div key={key} className="mb-16 last:mb-0">
                      <h6 className="mb-8 text-gray-700 text-md">{t(`order_info.fields.${key}`) || key}</h6>
                      <p className="text-gray-900">
                        {typeof value === 'object' 
                          ? JSON.stringify(value, null, 2) 
                          : String(value)}
                      </p>
                    </div>
                  ))
                ) : (
                  <p>{String(infoData)}</p>
                )}
              </div>
            </div>
            
            <div className="gap-3 d-flex justify-content-center">
              <Link to="/" className="px-32 btn btn-outline-main py-18 rounded-8">
                {t('order_info.back_to_home') || 'Back to Home'}
              </Link>
              <Link to="/shop" className="px-32 btn btn-main py-18 rounded-8">
                {t('order_info.continue_shopping') || 'Continue Shopping'}
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ShippingOne */}
      <ShippingOne />

      {/* FooterTwo */}
      <FooterTwo />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default OrderInfo; 